<template>
   <div class="container_box">
     <nav-box @userInfo='getUserInfo'></nav-box>
      <el-table :data="taskList"  ref="task"  tooltip-effect="dark"  style="width: 100%;" >
            <el-table-column prop="scaleName" label="量表名称"  width="180"></el-table-column>
            <el-table-column prop="scaleDesc" label="量表描述" v-if='notPhone'></el-table-column>
            <el-table-column fixed="right" label="操作" align="right" width='120'>
                <!-- <template slot="header">
                    <el-input v-model="search" size="mini" placeholder="输入关键字搜索"/>
                </template> -->
                <template slot-scope="scope">
                    <el-button size="mini" type="primary"  @click="taskStart(scope.$index, scope.row)">开始测试</el-button>
                </template> 
            </el-table-column>
      </el-table>
   </div>
</template>
<script>
  import { mapMutations } from "vuex";
  import { request } from "../../network/request";
  import NavBox from '../../components/NavBox.vue'
  export default {
    name:'PsychologyTest',
    data(){
        return{
          userInfo:{},
          taskList:[],
          totalCount:0,
          currentPage:1,
          notPhone:true,
        }
    },
    created(){
      this.loadingTask();
      this.checkIsPhone()
    },
    methods:{
    ...mapMutations(["changeLogin"]),
    checkIsPhone() { 
      var userAgentInfo=navigator.userAgent; 
      var Agents =new Array("Android","iPhone","SymbianOS","Windows Phone","iPad","iPod"); 
      for(var v=0;v<Agents.length;v++) { 
        if(userAgentInfo.indexOf(Agents[v])>0) { 
          this.notPhone=false; 
          break; 
        } 
      } 
    }, 
    getUserInfo(val){
        this.userInfo = val;
    },
    loadingTask(){
      request({
        url:'/api/AssessTask/Search',
        method:'post',
        data:{
          pageIndex:this.currentPage,
          pageSize:15,
          processStatus:1,
        }
      }).then(res =>{
        if(res.data.code === 21002){
            this.changeLogin({ userToken: "" });
            this.$router.push('/login')
        }else if(res.data.code === 0){
          this.taskList = res.data.content;
        }else{
          this.$message({type:'error',message:res.data.msg,});
        }

      })
    },
    taskStart(index,row){
      this.$router.push('/scaleInfo/'+row.assessTaskNo);
    }

  },
   components:{
    NavBox
  }
 }
</script>
<style scoped>
  .container_box{
    padding:100px;
    padding-top:100px;
  }
  @media screen and (max-width:480px){
    .container_box{
      padding:10px;
      padding-top:100px;
      padding-bottom:50px;
    }
  }
</style>